$shm_hitalama_profile_register $mol_section
	title \Регистрация
	profiles $shm_hitalama_profile_dict
	account_exist_message \Пользовать "{login}" уже существует
	content /
		<= Login_label $mol_labeler
			title \Логин
			content /
				<= Login $mol_string
					value? <=> login? \
		<= Password_label $mol_labeler
			title \Пароль
			content /
				<= Password $mol_password
					value? <=> passwond? \
					submit? <=> submit? null
		<= Submit $mol_button_major
			title <= submit_title \Зарегистрироваться
			click? <=> submit? null
			enabled? <=> submit_enabled? true
		^ message_view / <= Message $mol_text text <= message? \
